import React from "react";

// function capitalizeFirstLetter(string) {
//   return string.charAt(0).toUpperCase() + string.slice(1);
// }

function PartidoCards({ equipoA, equipoB, onEliminar }) {
  return (
    <div className="custom-card" style={{ minHeight: "3rem" }}>
      <div className="custom-card-body d-flex flex-column justify-content-center align-items-center">
        <h5 className="custom-card-title mb-0">
          {equipoA} vs {equipoB}
        </h5>
        <button className="custom-button" onClick={onEliminar}>
          Eliminar
        </button>
      </div>
    </div>
  );
}

export default PartidoCards;
